<template>
  <div v-if="socialIcons.length >= 1" id="cd-social-icons" class="d-flex align-items-center">
    <a
      v-for="(socialIcon, index) in socialIcons"
      :key="socialIcon.name + index"
      :href="socialIcon.url"
      target="_blank"
      class="text-secondary clickable-icon"
    >
      <i :class="socialIcon.class" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    company: { type: Object, required: true },
  },
  computed: {
    socialIcons() {
      /*
        since the social icons arn't an array of items (as I think they should be)
        I've opted to generate one based on the company object. The reasoning:
        if we ever upgrade the company call (which I think we will) icons will
        most likely be in an array. As to not rewrite the ui too much, here :)
        Cheers - Jesse Garcia
      */
      const availableIcons = ["website", "facebook", "instagram", "twitter"];
      return Object.keys(this.company)
        .reduce((icons, companyKey) => {
          const value = this.company[companyKey];
          if (availableIcons.includes(companyKey) && value) {
            const icon = {
              name: companyKey,
              url: value,
              class: `fab fa-fw fa-${companyKey} fa-sm`,
            };
            switch (companyKey) {
              case "facebook":
                icon.class = `fab fa-fw fa-${companyKey}-f fa-sm`;
                break;
              case "website":
                icon.class = "fas fa-fw fa-external-link-square-alt fa-sm";
                break;
              default:
                break;
            }
            icons.push(icon);
          }
          return icons;
        }, [])
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    },
  },
};
</script>

<style scoped>
#cd-social-icons {
  font-size: 2rem;
}
</style>
